import React from "react";
import { Row, Col, Button, Card } from "react-bootstrap";
import * as Assets from "../../utils/svg_assets";
import * as PageRoutes from "../../utils/route_pages";
import { priceDecimal, dateFormater } from "../../utils/utilities";
import { useNavigate } from "react-router-dom";
import MyVoucherDashboard from "./my_voucher";
import ApiUtils from "../../utils/api_utils";

const ActivitiesContent = (p) => {
  const { dataActivities, navigate } = p;

  return (
    <Col xs={6} sm={6} md={6}>
      <Card
        className="activities-content"
        onClick={() => {
          navigate(PageRoutes.pointHistory + "/redeemed");
        }}
      >
        <Row>
          <Col xs={9} sm={9} md={9}>
            {dataActivities.name}
          </Col>
          <Col xs={3} sm={3} md={3}>
            <img
              src={ApiUtils.validateImgUrl({ url: dataActivities.icon })}
              className="activities-img"
              alt="activities_image"
            />
          </Col>
        </Row>
        <Row>
          <Col className="activities-lbl">
            {priceDecimal(dataActivities.value)}
          </Col>
        </Row>
        <Row>
          <Col className="activities-lbl-detail">
            {priceDecimal(dataActivities.points)} Pts
          </Col>
        </Row>
      </Card>
    </Col>
  );
};

const PointSummary = (props) => {
  const navigate = useNavigate();
  const { pointSummaryData, expiredDate } = props;
  const activitiesData =
    pointSummaryData.point_categories.length > 0
      ? pointSummaryData.point_categories
      : [];

  return (
    <div className="home-point-content">
      <Row className="home-point">
        <Col>
          <div>Current Point</div>
          <div className="point-info">
            <Col xs={11} sm={11} md={11}>
              <img
                src={Assets.iconOval}
                className="point-img"
                alt="coin_image"
              />
              {priceDecimal(pointSummaryData.remaining_points)} Pts
            </Col>
            <Col xs={1} sm={1} md={1}>
              <div
                className="badge-info"
                onClick={() => {
                  navigate("/summary-info/point");
                }}
              >
                ?
              </div>
            </Col>
          </div>
          <div>Point will expire on {dateFormater(expiredDate)}</div>
        </Col>
      </Row>
      <Row className="home-point-detail">
        <Col className="left-detail-info">
          <Row className="point-earned">
            <div> Total Point Earned </div>
            <div className="detail-info-point">
              {" "}
              {priceDecimal(pointSummaryData.total_points)} Pts{" "}
            </div>
          </Row>
          <Row>
            <div> Total Point Redeemed </div>
            <div className="detail-info-point">
              {" "}
              {priceDecimal(pointSummaryData.redeemed_points)} Pts{" "}
            </div>
          </Row>
        </Col>
        <Col className="right-detail-info">
          <Row>
            <Col className="lbl-next-reward"> Unlock Next Reward </Col>
          </Row>
          {pointSummaryData.featured_reward ? (
            <div>
              <Row>
                <Col xs={4} sm={4} md={4}>
                  <img
                    src={
                      pointSummaryData.featured_reward
                        ? ApiUtils.validateImgUrl({
                            url: pointSummaryData.featured_reward
                              .thumbnail_img_url,
                          })
                        : ""
                    }
                    className="next-img"
                    alt="image"
                  />
                </Col>
                <Col xs={8} sm={8} md={8}>
                  <Row className="next-reward-point">
                    <div>
                      {pointSummaryData.featured_reward
                        ? pointSummaryData.featured_reward.name
                        : ""}
                    </div>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col className="more-point">
                  {" "}
                  {priceDecimal(
                    pointSummaryData.featured_reward
                      ? pointSummaryData.featured_reward.points
                      : 0
                  )}{" "}
                  more points
                </Col>
              </Row>
            </div>
          ) : (
            <div>
              <Row>
                <Col className="no-reward">No Reward</Col>
              </Row>
            </div>
          )}
        </Col>
      </Row>
      <Row className="home-button">
        <Button
          variant="danger"
          className="btn-point"
          onClick={() => {
            navigate(PageRoutes.reward);
          }}
        >
          <Row>
            <Col xs={2} sm={2} md={2}>
              <img src={Assets.iconRewardWhite} alt="card_item_image" />
            </Col>
            <Col xs={8} sm={8} md={8}>
              Redeem Point Rewards
            </Col>
          </Row>
        </Button>
        <Button
          variant="outline-danger"
          className="btn-point-outline"
          onClick={() => {
            navigate(PageRoutes.pointHistory);
          }}
        >
          Your Point History
        </Button>
      </Row>
      <div className="activities-point">
        <div className="activities-header">Activities</div>
        <Row>
          {!activitiesData
            ? ""
            : activitiesData.map((data, index) => (
                <ActivitiesContent
                  key={index}
                  dataActivities={data}
                  navigate={navigate}
                />
              ))}
        </Row>
      </div>
      <MyVoucherDashboard />
    </div>
  );
};

export default PointSummary;
